module.exports = __webpack_public_path__ + "media/unipod/about-pods-1-d50939de.png";